var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftarrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15557 15.1337L0.934547 8.61936C0.62539 8.35436 0.62539 7.86855 0.934547 7.60355L8.15557 1.08917C8.61931 0.669604 9.37012 0.978761 9.37012 1.59707L9.37012 14.6258C9.37012 15.2441 8.61931 15.5533 8.15557 15.1337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrowicon);
export default __webpack_public_path__ + "static/media/leftarrowicon.7b5636946f0a55a89febb065471cc2f2.svg";
export { ForwardRef as ReactComponent };